import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isUserAdmin, isUserClaimGroupConsultant } from '../user/userUtils';
import { Button } from '.';
export default function StartReviewButton(_ref) {
  let {
    text,
    loading,
    reviewedObject,
    reviewedObjectClass,
    reviewType,
    onClick
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const renderButton = () => {
    if (reviewedObject.active_change_set && reviewedObject.active_change_set.review_type !== reviewType) {
      return /*#__PURE__*/React.createElement("div", null, t('another_review_has_already_been_started'));
    } else if (reviewedObject.active_change_set?.review_type === reviewType) {
      return /*#__PURE__*/React.createElement("div", null, t(`${reviewType}_for_this_${reviewedObjectClass}_has_already_been_started`));
    }
    if (!reviewedObject.active_change_set && (isUserClaimGroupConsultant(user, reviewedObject) || isUserAdmin(user))) {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: () => onClick(reviewType),
        loading: loading,
        icon: "zoom_in",
        disabled: reviewedObject.is_locked // is_locked only exists for claims at the moment
        ,
        iconPosition: "left",
        variant: "info",
        size: "md"
      }, text);
    }
  };
  return renderButton();
}